import { Vector } from '../../../../../types';
import { BulletsEntity } from './BulletsEntity';

export class EnemyBulletsEntity extends BulletsEntity {
  initialDurationUntilShot = 1;
  minimumDuration = 0.5;
  timer = this.initialDurationUntilShot;
  velocity: Vector = [0, -100, 0];

  step(delta: number) {
    super.step(delta);
    this.timer -= delta;
  }
}
